import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Badge } from '../../ui/badge';
import { formatCurrencyCompact } from '../../../lib/currency';

export function AgingBucketCards({ agingSummary, activeBucket, setActiveBucket, currency }) {
  if (!agingSummary) return null;

  return (
    <div className="grid grid-cols-5 gap-3" data-testid="aging-buckets">
      {agingSummary.buckets.map(bucket => (
        <Card
          key={bucket.key}
          className={`cursor-pointer transition-all hover:shadow-md ${activeBucket === bucket.key ? 'ring-2 ring-offset-1' : ''}`}
          style={activeBucket === bucket.key ? { '--tw-ring-color': bucket.color } : {}}
          onClick={() => setActiveBucket(activeBucket === bucket.key ? null : bucket.key)}
          data-testid={`aging-bucket-${bucket.key}`}
        >
          <CardContent className="pt-4 pb-3">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs font-medium text-muted-foreground">{bucket.label}</span>
              {activeBucket === bucket.key && (
                <Badge className="text-[9px]" style={{ backgroundColor: bucket.color, color: '#fff' }}>Active</Badge>
              )}
            </div>
            <p className="text-xl font-bold" style={{ color: bucket.color }}>{formatCurrencyCompact(bucket.amount, currency)}</p>
            <div className="flex items-center justify-between mt-1">
              <span className="text-xs text-muted-foreground">{bucket.count} invoices</span>
              {agingSummary.total_outstanding > 0 && (
                <span className="text-xs font-medium" style={{ color: bucket.color }}>
                  {((bucket.amount / agingSummary.total_outstanding) * 100).toFixed(0)}%
                </span>
              )}
            </div>
            <div className="mt-2 h-1.5 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all"
                style={{
                  width: `${agingSummary.total_outstanding > 0 ? (bucket.amount / agingSummary.total_outstanding) * 100 : 0}%`,
                  backgroundColor: bucket.color,
                }}
              />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export function AgingDistributionBar({ agingSummary, activeBucket, setActiveBucket, currency }) {
  if (!agingSummary || agingSummary.total_outstanding <= 0) return null;

  return (
    <div className="rounded-lg border p-3 bg-muted/20" data-testid="aging-bar-chart">
      <p className="text-xs font-semibold text-muted-foreground mb-2">Aging Distribution</p>
      <div className="flex h-8 rounded-lg overflow-hidden gap-0.5">
        {agingSummary.buckets.map(bucket => {
          const pct = (bucket.amount / agingSummary.total_outstanding) * 100;
          if (pct < 0.5) return null;
          return (
            <div
              key={bucket.key}
              className={`flex items-center justify-center text-white text-[10px] font-bold cursor-pointer hover:opacity-85 transition-all ${activeBucket === bucket.key ? 'ring-2 ring-inset ring-white' : ''}`}
              style={{ width: `${pct}%`, backgroundColor: bucket.color }}
              onClick={() => setActiveBucket(activeBucket === bucket.key ? null : bucket.key)}
              title={`${bucket.label}: ${formatCurrencyCompact(bucket.amount, currency)} (${pct.toFixed(0)}%)`}
            >
              {pct > 10 ? `${pct.toFixed(0)}%` : ''}
            </div>
          );
        })}
      </div>
      <div className="flex items-center gap-3 mt-1.5 flex-wrap">
        {agingSummary.buckets.map(bucket => (
          <div key={bucket.key} className="flex items-center gap-1">
            <span className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: bucket.color }} />
            <span className="text-[10px] text-muted-foreground">{bucket.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
